import { adminQuery } from '../adminQuery';

interface Params {
  username: string;
  groupname: string;
}

export const adminRemoveUserFromGroup = async (body: Params) => {
  return await adminQuery.post({
    path: '/removeUserFromGroup',
    params: {
      body,
    },
  });
};
